
import React, { useState, useEffect } from "react";
import { RiDeleteBin6Line } from "react-icons/ri";
import { FaRegEdit, FaPlus, FaFileExport } from "react-icons/fa";
import { BsFillEyeFill } from "react-icons/bs";
import { IoSearch, IoClose } from "react-icons/io5";
import ReactPaginate from "react-paginate";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useNavigate } from "react-router-dom";
import { useSearchParams } from "react-router-dom";
import AdminNavbar from "../Navbar/Navbar1";
import "./User.css";
import AdminSidebar from "../Navbar/AdminSidebar";

const BASE_URL = process.env.REACT_APP_BASE_URL;

const UserArtist = () => {
    const [data, setData] = useState([]);
    const [user, setUser] = useState('Artist')
    const [currentPage, setCurrentPage] = useState(0);
    const [searchQuery, setSearchQuery] = useState("");
    const [filterOption, setFilterOption] = useState("0");
    const [selectedUsers, setSelectedUsers] = useState([]);
    const [searchParams, setSearchParams] = useSearchParams();

    // Modal states
    const [showEditModal, setShowEditModal] = useState(false);
    const [showAddModal, setShowAddModal] = useState(false);
    
    // Form states
    const [editingUser, setEditingUser] = useState(null);
    const [editForm, setEditForm] = useState({
        customID: "", firstName: "", lastName: "", email: "", phoneNumber: "",
        isBlocked: false, isAproved: false, isVerified: false
    });
    const [addMode, setAddMode] = useState("single");
    const [newUserForm, setNewUserForm] = useState({
        firstName: "", lastName: "", email: "", password: "", phoneNumber: "", customID: ""
    });
    const [csvData, setCsvData] = useState("");
    const [isLoading, setIsLoading] = useState(false);

    const token = localStorage.getItem("accessToken");
    const navigate = useNavigate();
    const itemsPerPage = 10;

    const getRoleByFilterOption = (filter) => {
        if(filter === "1") return "Patron";
        if(filter === "2")  return "Partner";
        if(filter === "3")  return "Art-lover";
        return "Artist";
    };
    
    const getUser = async () => {
        if (searchParams.get("value")) setFilterOption(searchParams.get("value").toString());
        setIsLoading(true);
        try {
            setUser(getRoleByFilterOption(searchParams.get("value")));
            let role = getRoleByFilterOption(searchParams.get("value"));
            const cacheBuster = `&t=${new Date().getTime()}`;
            const response = await fetch(`${BASE_URL}/admin/users?role=${role}${cacheBuster}`, {
                method: 'GET',
                headers: { 'Authorization': `Bearer ${token}` },
            });
            const responseData = await response.json();
            console.log("API Response:", responseData);
            if (!response.ok) throw new Error(responseData.message || "Failed to fetch data.");
            const sorted = (responseData.data || []).sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));
            setData(sorted);
        } catch (error) {
            console.error("Error fetching user data:", error);
        } finally {
            setIsLoading(false);
        }
    };


    useEffect(() => {
        // if(searchParams.get("value")){
        //     setFilterOption(searchParams.get("value").toString())
        // };
        getUser();
    }, [filterOption]);

    // --- NEW DYNAMIC VERIFICATION TOGGLE FUNCTION ---
    const toggleVerification = async (user) => {
        const newStatus = !user.isVerified;
        const confirmMsg = newStatus ? "verify" : "unverify";

        console.log("=== ADMIN VERIFICATION TOGGLE ===");
        console.log("User ID:", user._id);
        console.log("Current Status:", user.isVerified);
        console.log("New Status:", newStatus);
        console.log("User Object:", user);
        console.log("================================");
        
        if (!window.confirm(`Are you sure you want to ${confirmMsg} this user?`)) return;

        const toastId = toast.loading(`Updating status to ${newStatus ? "Verified" : "Not Verified"}...`);

        try {
            // Hum sirf verification status update kar rahe hain
            const response = await fetch(`${BASE_URL}/admin/updateuser/${user._id}`, {
                method: "PATCH",
                headers: { 'Authorization': `Bearer ${token}`, 'Content-Type': 'application/json' },
                body: JSON.stringify({ isVerified: newStatus }) 
            });

            if (!response.ok) throw new Error("Status update failed");

            // UI ko turant update karein (Optimistic Update)
            setData(prevData => prevData.map(item => 
                item._id === user._id ? { ...item, isVerified: newStatus } : item
            ));

            toast.update(toastId, { render: `User ${newStatus ? "Verified" : "Unverified"} Successfully!`, type: "success", isLoading: false, autoClose: 2000 });
            
   // ✅ Refresh data from server after 1 second to confirm
        setTimeout(() => {
            getUser();
            console.log("Data refreshed after verification toggle");
        }, 1000);

        } catch (error) {
            console.error(error);
            toast.update(toastId, { render: `Error: ${error.message}`, type: "error", isLoading: false, autoClose: 3000 });
        }
    };

    // Edit Modal Logic
    const handleEditClick = (user) => {
        setEditingUser(user);
        setEditForm({
            customID: user.customID || "",
            firstName: user.firstName || "",
            lastName: user.lastName || "",
            email: user.email || "",
            phoneNumber: user.phoneNumber?.number || "",
            isBlocked: user.isBlocked || false,
            isAproved: user.isAproved || false,
            isVerified: user.isVerified || false
        });
        setShowEditModal(true);
    };

    const handleEditSubmit = async (e) => {
        e.preventDefault();
        const toastId = toast.loading("Updating user...");
        try {
            const payload = { ...editForm, phoneNumber: { number: editForm.phoneNumber } };
            const response = await fetch(`${BASE_URL}/admin/updateuser/${editingUser._id}`, {
                method: "PATCH",
                headers: { 'Authorization': `Bearer ${token}`, 'Content-Type': 'application/json' },
                body: JSON.stringify(payload)
            });
            if (!response.ok) throw new Error("Update failed");
            
            toast.update(toastId, { render: "User updated successfully!", type: "success", isLoading: false, autoClose: 2000 });
            setShowEditModal(false);
            setTimeout(() => getUser(), 500);
        } catch (error) {
            toast.update(toastId, { render: `Error: ${error.message}`, type: "error", isLoading: false, autoClose: 3000 });
        }
    };

    // Add User Logic
    const handleAddSingleArtist = async (e) => {
        e.preventDefault();
        const toastId = toast.loading("Adding artist...");
        try {
            const payload = { ...newUserForm, role: getRoleByFilterOption(), phoneNumber: { number: newUserForm.phoneNumber } };
            const response = await fetch(`${BASE_URL}/admin/users/add-single-artist`, {
                method: "POST",
                headers: { 'Authorization': `Bearer ${token}`, 'Content-Type': 'application/json' },
                body: JSON.stringify(payload)
            });
            const data = await response.json();
            if (!response.ok) throw new Error(data.message || "Failed to add artist");

            toast.update(toastId, { render: "Artist added successfully!", type: "success", isLoading: false, autoClose: 2000 });
            setShowAddModal(false);
            setNewUserForm({ firstName: "", lastName: "", email: "", password: "", phoneNumber: "", customID: "" });
            setTimeout(() => getUser(), 500);
        } catch (error) {
            toast.update(toastId, { render: `Error: ${error.message}`, type: "error", isLoading: false, autoClose: 3000 });
        }
    };

    const handleAddBulkArtists = async () => {
        if (!csvData.trim()) return toast.warning("Please paste CSV data");
        const toastId = toast.loading("Processing bulk upload...");
        try {
            const lines = csvData.trim().split("\n");
            const artists = lines.map(line => {
                const [firstName, lastName, email, role, password, phoneNumber, customID] = line.split(",").map(s => s.trim());
                return { firstName, lastName, email, role, password, phoneNumber: { number: phoneNumber }, customID };
            });
            
            if (artists.length === 0) throw new Error("No valid data to upload.");

            const response = await fetch(`${BASE_URL}/admin/users/add-bulk-artists`, {
                method: "POST",
                headers: { 'Authorization': `Bearer ${token}`, 'Content-Type': 'application/json' },
                body: JSON.stringify({ artists })
            });
            const result = await response.json();
            if (!response.ok) throw new Error(result.message || "Bulk add failed");
            
            toast.update(toastId, { render: `Added ${result.data.createdCount} artists successfully.`, type: "success", isLoading: false, autoClose: 3000 });
            setShowAddModal(false);
            setCsvData("");
            setTimeout(() => getUser(), 500);
        } catch (error) {
            toast.update(toastId, { render: `Error: ${error.message}`, type: "error", isLoading: false, autoClose: 3000 });
        }
    };

    // Delete Logic
    const handleDelete = async (userId) => {
        if (!window.confirm("Are you sure you want to delete this user?")) return;
        const toastId = toast.loading("Deleting user...");
        try {
            const response = await fetch(`${BASE_URL}/admin/deleteuser/${userId}`, {
                method: "DELETE",
                headers: { 'Authorization': `Bearer ${token}` }
            });
            if (!response.ok) throw new Error("Delete failed");
            
            toast.update(toastId, { render: "User deleted successfully", type: "success", isLoading: false, autoClose: 2000 });
            setTimeout(() => getUser(), 500);
        } catch (err) {
            toast.update(toastId, { render: `Error: ${err.message}`, type: "error", isLoading: false, autoClose: 3000 });
        }
    };

    const handleBulkDelete = async () => {
        if (selectedUsers.length === 0) return toast.warning("Please select at least one user to delete.");
        if (!window.confirm(`Are you sure you want to delete ${selectedUsers.length} users?`)) return;
        
        const toastId = toast.loading(`Deleting ${selectedUsers.length} users...`);
        try {
            await Promise.all(selectedUsers.map(id => fetch(`${BASE_URL}/admin/deleteuser/${id}`, {
                method: "DELETE",
                headers: { 'Authorization': `Bearer ${token}` }
            })));
            toast.update(toastId, { render: "Selected users deleted.", type: "success", isLoading: false, autoClose: 2000 });
            setSelectedUsers([]);
            setTimeout(() => getUser(), 500);
        } catch (err) {
            toast.update(toastId, { render: `Error: ${err.message}`, type: "error", isLoading: false, autoClose: 3000 });
        }
    };
    
    // Export to Excel
    const exportToExcel = () => {
        if (!filteredData || filteredData.length === 0) return toast.warning("No data to export");

        const toastId = toast.loading("Preparing export...");
        try {
            const tableHTML = `
                <table border="1">
                    <thead>
                        <tr>
                            <th>Custom ID</th><th>First Name</th><th>Last Name</th><th>Email</th>
                            <th>Phone</th><th>Role</th><th>Registered On</th>
                            <th>Status</th><th>Approval</th><th>Verified</th>
                        </tr>
                    </thead>
                    <tbody>
                        ${filteredData.map(item => `
                            <tr>
                                <td>${item.customID || ""}</td>
                                <td>${item.firstName || ""}</td>
                                <td>${item.lastName || ""}</td>
                                <td>${item.email || ""}</td>
                                <td>${item.phoneNumber?.number || ""}</td>
                                <td>${item.role || getRoleByFilterOption()}</td>
                                <td>${new Date(item.createdAt).toLocaleString()}</td>
                                <td>${item.isBlocked ? "Blocked" : "Active"}</td>
                                <td>${item.isAproved ? "Approved" : "Rejected"}</td>
                                <td>${item.isVerified ? "Verified" : "Not Verified"}</td>
                            </tr>
                        `).join('')}
                    </tbody>
                </table>`;

            const blob = new Blob([tableHTML], { type: "application/vnd.ms-excel;charset=utf-8;" });
            const link = document.createElement("a");
            const url = URL.createObjectURL(blob);
            
            link.setAttribute("href", url);
            link.setAttribute("download", `${getRoleByFilterOption()}_users_${new Date().toISOString().split("T")[0]}.xls`);
            link.style.visibility = "hidden";
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);

            toast.update(toastId, { render: "Data exported successfully!", type: "success", isLoading: false, autoClose: 2000 });
        } catch (error) {
            toast.update(toastId, { render: "Failed to export data", type: "error", isLoading: false, autoClose: 3000 });
        }
    };

    // Filtering and Pagination
    const filteredData = data.filter(item => {
        if (!item) return false;
        const searchStr = searchQuery.toLowerCase();
        return (
            item.firstName?.toLowerCase().includes(searchStr) ||
            item.email?.toLowerCase().includes(searchStr) ||
            item.customID?.toLowerCase().includes(searchStr) ||
            item.phoneNumber?.number?.includes(searchQuery)
        );
    });
    
    const pageCount = Math.ceil(filteredData.length / itemsPerPage);
    const currentItems = filteredData.slice(currentPage * itemsPerPage, (currentPage + 1) * itemsPerPage);

    return (
        <>
            <AdminNavbar />
            <div className="dashboard-layout">
                <AdminSidebar />
            
            <div className="admin-usercontainer">
                <div className="admin-row-container">
                    <h2 style={{fontWeight:"semi-bold"}}>Manage Users - <span style={{ color: "#AD2F3B", fontWeight:"bold" }}>{user}s </span>({data.length})</h2>
                    <div style={{ display: "flex", gap: "10px", alignItems: "center" }}>
                        <button className="export-btn" onClick={exportToExcel}><FaFileExport /> Export to Excel</button>
                        <FaPlus className="plus" title="Add User" onClick={() => setShowAddModal(true)} />
                    </div>
                </div>

                <div className="filters-container">
                    <div className="searchbar"><IoSearch className="searchicon" /><input type="search" placeholder="Search..." value={searchQuery} onChange={(e) => setSearchQuery(e.target.value)} /></div>
                    <select className="filter-select" onChange={(e) => { setFilterOption(e.target.value); setCurrentPage(0); searchParams.set("value", e.target.value);  setSearchParams(searchParams)}} value={filterOption}>
                        <option value="0">Artist</option><option value="1">Patron</option><option value="2">Partner</option><option value="3">Art-Lover</option>
                    </select>
                </div>

                <button className="delete-selected-button" onClick={handleBulkDelete}>Delete Selected</button>

                {isLoading ? (
                    <div className="loading-container">
                        <div className="loader"></div>
                        <p>Loading users...</p>
                    </div>
                ) : (
                    <>
                        <table className="admin-user-table">
                            <thead className="admin-table-header">
                        <tr>
                            <th><input type="checkbox" onChange={e => setSelectedUsers(e.target.checked ? currentItems.map(u => u._id) : [])} checked={selectedUsers.length === currentItems.length && currentItems.length > 0} /></th>
                            <th>Custom Id</th><th>First Name</th><th>Last Name</th><th>Email</th><th>Phone</th><th>Registered On</th><th>Status</th><th>Approval</th><th>Verified</th><th>Actions</th>
                        </tr>
                    </thead>
                    <tbody className="admin-table-body">
                        {currentItems.map((item) => (
                            <tr key={item._id}>
                                <td><input type="checkbox" checked={selectedUsers.includes(item._id)} onChange={() => setSelectedUsers(prev => prev.includes(item._id) ? prev.filter(id => id !== item._id) : [...prev, item._id])} /></td>
                                <td>{item.customID || <span style={{color: '#999'}}>Not assigned</span>}</td>
                                <td>{item.firstName || 'N/A'}</td>
                                <td>{item.lastName || 'N/A'}</td>
                                <td>{item.email || 'N/A'}</td>
                                <td>{item.phoneNumber?.number || 'N/A'}</td>
                                <td>{new Date(item.createdAt).toLocaleString()}</td>
                                
                                {/* Status Toggle */}
                                <td><span className={`badge ${item.isBlocked ? "badge-block" : "badge-unblock"}`}>{item.isBlocked ? "Blocked" : "Active"}</span></td>
                                
                                {/* Approval Status */}
                                <td><span className={`badge ${item.isAproved ? "badge-approved" : "badge-rejected"}`}>{item.isAproved ? "Approved" : "Rejected"}</span></td>
                                
                                {/* DYNAMIC VERIFIED CLICKABLE BADGE */}
                                <td 
                                    onClick={() => toggleVerification(item)} 
                                    style={{
                                        cursor: 'pointer',
                                        userSelect: 'none'
                                    }} 
                                    title="Click to toggle verification status"
                                >
                                    <span className={`badge ${item.isVerified ? "badge-verified" : "badge-verify"}`}>
                                        {item.isVerified ? "✓ Verified" : "✗ Not Verified"}
                                    </span>
                                    
                                    {/* 🔍 DEBUG: Show raw value in development */}
                                    {process.env.NODE_ENV === 'development' && (
                                        <div style={{ fontSize: '10px', color: '#666', marginTop: '2px' }}>
                                            Raw: {String(item.isVerified)}
                                        </div>
                                    )}
                                </td>
                                
                                <td className="viewicon">
                                    <FaRegEdit title="Edit" className="edit" onClick={() => handleEditClick(item)} />
                                    <BsFillEyeFill
                    title="View"
                    className="view"
                    onClick={() => {
                    localStorage.setItem("artId", item._id);
                    navigate("/artistProfile");
                    }}
                />
                                    <RiDeleteBin6Line title="Delete" className="delete" onClick={() => handleDelete(item._id)} />
                                </td>
                            </tr>
                        ))}
                    </tbody>
                        </table>
                        <ReactPaginate previousLabel={"<"} nextLabel={">"} pageCount={pageCount} onPageChange={(p) => setCurrentPage(p.selected)} containerClassName={"pagination"} activeClassName={"active"} />
                    </>
                )}
            </div>
            </div>
            {/* Modals Code Remains Same */}
            {showAddModal && (
                <div className="modal-overlay" onClick={() => setShowAddModal(false)}>
                    <div className="modal-card" onClick={(e) => e.stopPropagation()}>
                        <div className="modal-header"><h3>Add New Artists</h3><IoClose className="modal-close" onClick={() => setShowAddModal(false)} /></div>
                        <div className="add-tabs">
                            <button type="button" className={`tab-btn ${addMode === "single" ? "active" : ""}`} onClick={() => setAddMode("single")}>Add Single Artist</button>
                            <button type="button" className={`tab-btn ${addMode === "bulk" ? "active" : ""}`} onClick={() => setAddMode("bulk")}>Add Bulk Artists</button>
                        </div>
                        {addMode === "single" ? (
                            <form onSubmit={handleAddSingleArtist} className="modal-form">
                                <div className="form-row">
                                    <div className="form-group"><label>First Name</label><input type="text" value={newUserForm.firstName} onChange={(e) => setNewUserForm({...newUserForm, firstName: e.target.value})} required /></div>
                                    <div className="form-group"><label>Last Name</label><input type="text" value={newUserForm.lastName} onChange={(e) => setNewUserForm({...newUserForm, lastName: e.target.value})} required /></div>
                                </div>
                                <div className="form-row">
                                    <div className="form-group"><label>Email</label><input type="email" value={newUserForm.email} onChange={(e) => setNewUserForm({...newUserForm, email: e.target.value})} required /></div>
                                    <div className="form-group"><label>Phone Number</label><input type="text" value={newUserForm.phoneNumber} onChange={(e) => setNewUserForm({...newUserForm, phoneNumber: e.target.value})} /></div>
                                </div>
                                 <div className="form-row">
                                    <div className="form-group"><label>Custom ID</label><input type="text" value={newUserForm.customID} onChange={(e) => setNewUserForm({...newUserForm, customID: e.target.value})} required/></div>
                                    <div className="form-group"><label>Password</label><input type="password" value={newUserForm.password} onChange={(e) => setNewUserForm({...newUserForm, password: e.target.value})} required /></div>
                                </div>
                                <div className="modal-actions">
                                    <button type="button" className="btn-cancel" onClick={() => setShowAddModal(false)}>Cancel</button>
                                    <button type="submit" className="btn-submit">Add Artist</button>
                                </div>
                            </form>
                        ) : (
                            <div className="modal-form">
                                <div className="form-group"><label>Paste CSV Data</label><textarea className="csv-textarea" placeholder="firstName,lastName,email,password,phoneNumber,customID" value={csvData} onChange={(e) => setCsvData(e.target.value)} rows={8} /></div>
                                <p className="csv-note">Each line must contain values in this exact order: <strong>firstName, lastName, email, password, phoneNumber, customID</strong></p>
                                <div className="modal-actions">
                                    <button type="button" className="btn-cancel" onClick={() => setShowAddModal(false)}>Cancel</button>
                                    <button type="button" className="btn-submit" onClick={handleAddBulkArtists}>Add Bulk</button>
                                </div>
                            </div>
                        )}
                    </div>
                </div>
            )}
            
            {showEditModal && editingUser && (
                 <div className="modal-overlay" onClick={() => setShowEditModal(false)}>
                    <div className="modal-card" onClick={(e) => e.stopPropagation()}>
                        <div className="modal-header"><h3>Edit User Details</h3><IoClose className="modal-close" onClick={() => setShowEditModal(false)} /></div>
                        <form onSubmit={handleEditSubmit} className="modal-form">
                            <div className="form-group"><label>Custom ID</label><input type="text" name="customID" value={editForm.customID} onChange={(e) => setEditForm({...editForm, customID: e.target.value})} /></div>
                            <div className="form-row">
                                <div className="form-group"><label>First Name</label><input type="text" name="firstName" value={editForm.firstName} onChange={(e) => setEditForm({...editForm, firstName: e.target.value})} required /></div>
                                <div className="form-group"><label>Last Name</label><input type="text" name="lastName" value={editForm.lastName} onChange={(e) => setEditForm({...editForm, lastName: e.target.value})} required /></div>
                            </div>
                            <div className="form-group"><label>Email</label><input type="email" name="email" value={editForm.email} onChange={(e) => setEditForm({...editForm, email: e.target.value})} required /></div>
                            <div className="form-group"><label>Phone Number</label><input type="text" name="phoneNumber" value={editForm.phoneNumber} onChange={(e) => setEditForm({...editForm, phoneNumber: e.target.value})} /></div>
                            <div className="form-checkboxes">
                                <label className="checkbox-label"><input type="checkbox" name="isBlocked" checked={editForm.isBlocked} onChange={(e) => setEditForm({...editForm, isBlocked: e.target.checked})} /> Blocked</label>
                                <label className="checkbox-label"><input type="checkbox" name="isAproved" checked={editForm.isAproved} onChange={(e) => setEditForm({...editForm, isAproved: e.target.checked})} /> Approved</label>
                                <label className="checkbox-label"><input type="checkbox" name="isVerified" checked={editForm.isVerified} onChange={(e) => setEditForm({...editForm, isVerified: e.target.checked})} /> Verified</label>
                            </div>
                            <div className="modal-actions">
                                <button type="button" className="btn-cancel" onClick={() => setShowEditModal(false)}>Cancel</button>
                                <button type="submit" className="btn-submit">Modify</button>
                            </div>
                        </form>
                    </div>
                </div>
            )}
        </>
    );
};

export default UserArtist;



